import React from "react";

/**
 * BrandSpinner — un caricamento brandizzato col simbolo Pronto verde.
 *
 * Usalo al posto dei loader generici "border + animate-spin":
 *   <BrandSpinner />              // default ~64px
 *   <BrandSpinner size={48} />    // più piccolo
 *   <BrandSpinner label="Sto preparando il carosello..." />
 *
 * Animazioni:
 *   - Il simbolo "respira" (scale 0.9 ↔ 1) con keyframe pronto-pulse
 *   - Un anello sage circolare ruota lentamente intorno
 *
 * Le keyframes vivono in `index.css` (sezione "Animations · Brand spinner").
 */
export default function BrandSpinner({ size = 64, label = "", className = "" }) {
  const ringSize = size + 16;
  return (
    <div
      className={`flex flex-col items-center justify-center ${className}`}
      role="status"
      aria-live="polite"
      data-testid="brand-spinner"
    >
      <div className="relative" style={{ width: ringSize, height: ringSize }}>
        <div
          className="absolute inset-0 rounded-full border-2 border-[#7C8B6E]/15 border-t-[#7C8B6E] animate-spin"
          style={{ animationDuration: "1.4s" }}
        />
        <img
          src="/logo/mark-symbol-spinner.png"
          alt=""
          aria-hidden="true"
          className="absolute select-none"
          draggable="false"
          style={{
            width: size,
            height: size,
            top: (ringSize - size) / 2,
            left: (ringSize - size) / 2,
            animation: "pronto-pulse 1.6s ease-in-out infinite",
          }}
        />
      </div>
      {label ? (
        <p className="mt-3 text-[12px] uppercase tracking-[0.18em] text-[#6B6A65] font-medium">{label}</p>
      ) : null}
    </div>
  );
}
